/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of https://github.com/necolas/react-native-web.
 *
 */
import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment';
import invariant from 'fbjs/lib/invariant';
const initialURL = canUseDOM ? window.location.href : '';
class WebLinking {
    /**
     * An object mapping of event name
     * and all the callbacks subscribing to it
     */
    _eventCallbacks = {};
    _dispatchEvent(event, ...data) {
        const listeners = this._eventCallbacks[event];
        if (listeners != null && Array.isArray(listeners)) {
            listeners.map((listener) => {
                listener(...data);
            });
        }
    }
    /**
     * Adds a event listener for the specified event. The callback will be called when the
     * said event is dispatched.
     */
    addEventListener = (event, callback) => {
        if (!this._eventCallbacks[event]) {
            this._eventCallbacks[event] = [callback];
            return;
        }
        this._eventCallbacks[event].push(callback);
    };
    /**
     * Removes a previously added event listener for the specified event. The callback must
     * be the same object as the one passed to `addEventListener`.
     */
    removeEventListener = (event, callback) => {
        const callbacks = this._eventCallbacks[event];
        const filteredCallbacks = callbacks.filter((c) => c.toString() !== callback.toString());
        this._eventCallbacks[event] = filteredCallbacks;
    };
    canOpenURL(url) {
        // [NOTE] - The api doesn't actually take an input in, we no-op here so TS doesn't complain about unused vars
        typeof url === 'string';
        return Promise.resolve(true);
    }
    getInitialURL() {
        return Promise.resolve(initialURL);
    }
    /**
     * Try to open the given url in a secure fashion. The method returns a Promise object.
     * If the url opens, the promise is resolved. If not, the promise is rejected.
     * Dispatches the `onOpen` event if `url` is opened successfully
     */
    openURL(url, target = '_blank', features = 'noopener') {
        if (url) {
            try {
                open(url, target, features);
                this._dispatchEvent('onOpen', url);
                return Promise.resolve();
            }
            catch (e) {
                return Promise.reject(e);
            }
        }
    }
    _validateURL(url) {
        invariant(typeof url === 'string', 'Invalid URL: should be a string. Was: ' + url);
        invariant(url, 'Invalid URL: cannot be empty');
    }
}
const open = (url, target = '_blank', features = 'noopener') => {
    if (canUseDOM && url) {
        const urlToOpen = new URL(url, window.location.toString()).toString();
        window.open(urlToOpen, target, features);
        return window;
    }
};
export default new WebLinking();
//# sourceMappingURL=WebLinking.js.map